import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['version']),
    versionStr () {
      return this.version !== 'default' ? '&version=' + this.version : ''
    }
  }
}